import { Box, Button } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'


export default function SubscriptionExpiredBanner() {

    const navigate = useNavigate()

    return (
        <Box
            bg='blue.100'
            color='blue.800'
            p={4}
            mt={1}
            ml={1}
            mr={1}
            borderRadius='md'
            borderWidth='1px'
            borderColor='blue.300'
        >
            Your subscription is no longer active. You still have access to your saved journeys, but the ability to add new or modify existing journeys is disabled.{' '}
            <Button
                colorScheme='blue'
                variant='link'
                onClick={() => navigate('/preferences?selectedPlan=true')}
            >
                Renew subscription
            </Button>
        </Box>
    )
}